import styled from 'styled-components';
import { media } from 'utils/style';

import AddressCompanyNameField from 'components/AddressModal/components/AddressCompanyNameField/container';

export default styled(AddressCompanyNameField)`
  ${media.lessThan('extraSmall')`
    .floating {
      .header {
        min-height: 100px;
        height: 100%;
      }
  }
  `}
`;
